/* eslint-disable react/no-unknown-property */
import React from 'react';

export const principal_svg = (
  <i className='fas fa-home' style={{ marginRight: 2, fontSize: 16 }}></i>
  // <svg
  //   xmlns='http://www.w3.org/2000/svg'
  //   width='24'
  //   height='24'
  //   viewBox='0 0 24 24'
  //   fill='none'
  //   stroke='currentColor'
  //   strokeWidth='2'
  //   strokeLinecap='round'
  //   strokeLinejoin='round'
  //   className='feather feather-home feather-icon'
  // >
  //   <path d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'></path>
  //   <polyline points='9 22 9 12 15 12 15 22'></polyline>
  // </svg>
);

export const configuracion_svg = (
  <i className='fas fa-users-cog' style={{ marginRight: 4, fontSize: 16 }}></i>
  //<i className='fab fa-whmcs' style={{marginRight: 2, fontSize: 20}}></i>
  // <svg
  //   xmlns='http://www.w3.org/2000/svg'
  //   width='24'
  //   height='24'
  //   viewBox='0 0 24 24'
  //   fill='none'
  //   stroke='currentColor'
  //   strokeWidth='2'
  //   strokeLinecap='round'
  //   strokeLinejoin='round'
  //   className='feather feather-cpu feather-icon'
  // >
  //   <rect x='4' y='4' width='16' height='16' rx='2' ry='2'></rect>
  //   <rect x='9' y='9' width='6' height='6'></rect>
  //   <line x1='9' y1='1' x2='9' y2='4'></line>
  //   <line x1='15' y1='1' x2='15' y2='4'></line>
  //   <line x1='9' y1='20' x2='9' y2='23'></line>
  //   <line x1='15' y1='20' x2='15' y2='23'></line>
  //   <line x1='20' y1='9' x2='23' y2='9'></line>
  //   <line x1='20' y1='14' x2='23' y2='14'></line>
  //   <line x1='1' y1='9' x2='4' y2='9'></line>
  //   <line x1='1' y1='14' x2='4' y2='14'></line>
  // </svg>
);

export const administracionRH_svg = (
  <i
    className='fas fa-file-invoice-dollar'
    style={{ marginRight: 4, fontSize: 16 }}
  ></i>
  /*<svg
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 297 297'
    xlink='http://www.w3.org/1999/xlink'
    enableBackground='new 0 0 297 297'
  >
    <g fill='#737b88'>
      <path d='M46.169,61.873c3.286,2.507,7.98,1.876,10.488-1.408c22.071-28.917,55.546-45.5,91.843-45.5s69.772,16.584,91.843,45.5   c1.473,1.929,3.7,2.942,5.954,2.942c1.582,0,3.179-0.5,4.534-1.534c3.284-2.508,3.914-7.203,1.408-10.488   C227.312,18.729,189.501,0,148.5,0S69.688,18.729,44.762,51.385C42.255,54.67,42.885,59.365,46.169,61.873z' />
      <path d='m228.037,101.786c0,12.885 10.484,23.369 23.369,23.369s23.369-10.484 23.369-23.369-10.484-23.369-23.369-23.369-23.369,10.483-23.369,23.369z' />
      <path d='m275.322,132.91c-0.054-0.018-5.942-1.825-5.942-1.825-2.132-0.651-4.448-0.25-6.233,1.086l-11.741,8.791-11.741-8.791c-1.786-1.337-4.103-1.738-6.233-1.086 0,0-5.888,1.807-5.942,1.825-9.474,3.159-15.839,11.99-15.839,21.976v35.329c0,1.363 0.398,2.696 1.148,3.834l11.848,18.031v47.352c0,3.857 3.126,6.983 6.983,6.983h39.553c3.857,0 6.983-3.126 6.983-6.983v-47.352l11.848-18.031c0.749-1.139 1.148-2.472 1.148-3.834v-35.329c-5.68434e-14-9.986-6.366-18.817-15.84-21.976z' />
      <path d='m45.594,125.155c12.885,0 23.369-10.484 23.369-23.369s-10.484-23.369-23.369-23.369-23.37,10.483-23.37,23.369 10.484,23.369 23.37,23.369z' />
      <path d='m69.51,132.91c-0.054-0.018-5.942-1.825-5.942-1.825-2.133-0.651-4.447-0.25-6.233,1.086l-11.741,8.791-11.741-8.791c-1.785-1.337-4.103-1.738-6.233-1.086 0,0-5.888,1.807-5.942,1.825-9.474,3.159-15.839,11.99-15.839,21.976v35.329c0,1.363 0.398,2.696 1.148,3.834l11.848,18.031v47.352c0,3.857 3.126,6.983 6.983,6.983h39.552c3.857,0 6.983-3.126 6.983-6.983v-47.352l11.848-18.031c0.749-1.139 1.148-2.472 1.148-3.834v-35.329c0-9.986-6.366-18.817-15.839-21.976z' />
      <path d='m178.642,68.851c0-16.62-13.522-30.142-30.142-30.142s-30.142,13.522-30.142,30.142c0,16.621 13.522,30.142 30.142,30.142s30.142-13.521 30.142-30.142z' />
      <path d='m181.607,113.601l-.05-.016-8.603-2.64c-1.357-0.417-2.807,0.301-3.295,1.64l-18.09,49.635c-1.044,2.863-5.093,2.863-6.137,0l-18.09-49.635c-0.394-1.081-1.414-1.759-2.508-1.759-0.259,0-9.38,2.755-9.38,2.755-10.99,3.662-18.332,13.85-18.332,25.37v52.506c0,0.521 0.153,1.031 0.439,1.467l18.876,28.724v72.68c0,1.476 1.196,2.672 2.672,2.672h58.783c1.476,0 2.672-1.196 2.672-2.672v-72.68l18.876-28.724c0.286-0.436 0.439-0.946 0.439-1.467v-52.644c-0.001-11.47-7.372-21.641-18.272-25.212z' />
      <path d='m155.568,112.556c-0.747-0.814-1.84-1.224-2.946-1.224h-8.245c-1.105,0-2.198,0.41-2.946,1.224-1.157,1.261-1.325,3.082-0.504,4.505l4.407,6.644-2.063,17.405 4.063,10.808c0.396,1.087 1.933,1.087 2.33,0l4.063-10.808-2.063-17.405 4.407-6.644c0.822-1.423 0.654-3.244-0.503-4.505z' />
    </g>
  </svg>*/
);

export const prenominaCliente_svg = (
  <i
    className='fas fa-file-invoice-dollar'
    style={{ marginRight: 2, fontSize: 16 }}
  ></i>
  // <svg
  //   xmlns='http://www.w3.org/2000/svg'
  //   width='24'
  //   height='24'
  //   viewBox='0 0 24 24'
  //   stroke='currentColor'
  //   strokeWidth='2'
  //   enableBackground='new 0 0 297 297'
  //   className='feather feather-grid feather-icon'
  // >
  //   <rect x='3' y='3' width='7' height='7'></rect>
  //   <rect x='14' y='3' width='7' height='7'></rect>
  //   <rect x='14' y='14' width='7' height='7'></rect>
  //   <rect x='3' y='14' width='7' height='7'></rect>
  // </svg>
);

export const empresas_svg = (
  <i className='fas fa-building' style={{ marginRight: 4, fontSize: 16 }}></i>
  // <svg
  //   xmlns='http://www.w3.org/2000/svg'
  //   width='24'
  //   height='24'
  //   viewBox='0 0 24 24'
  //   stroke='currentColor'
  //   strokeWidth='2'
  //   enableBackground='new 0 0 297 297'
  //   className='feather feather-grid feather-icon'
  // >
  //   <rect x='3' y='3' width='7' height='7'></rect>
  //   <rect x='14' y='3' width='7' height='7'></rect>
  //   <rect x='14' y='14' width='7' height='7'></rect>
  //   <rect x='3' y='14' width='7' height='7'></rect>
  // </svg>
);

export const clientes_svg = (
  <i className='fas fa-users' style={{ marginRight: 4, fontSize: 16 }}></i>
  // <svg
  //   xmlns='http://www.w3.org/2000/svg'
  //   width='24'
  //   height='24'
  //   viewBox='0 0 24 24'
  //   fill='none'
  //   stroke='currentColor'
  //   strokeWidth='2'
  //   strokeLinecap='round'
  //   strokeLinejoin='round'
  //   className='feather feather-file-text feather-icon'
  // >
  //   <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'></path>
  //   <polyline points='14 2 14 8 20 8'></polyline>
  //   <line x1='16' y1='13' x2='8' y2='13'></line>
  //   <line x1='16' y1='17' x2='8' y2='17'></line>
  //   <polyline points='10 9 9 9 8 9'></polyline>
  // </svg>
);

export const empleado_svg = (
  <i className='fas fa-user-tie' style={{ marginRight: 5, fontSize: 15 }}></i>
);

export const finiquito_svg = (
  <i
    className='fas fa-user-alt-slash'
    style={{ marginRight: 5, fontSize: 15 }}
  ></i>
);
export const remision_svg = (
  <i
    className='fas fa-receipt'
    style={{ marginRight: 5, fontSize: 15 }}
  ></i>
);
export const operaciones_svg = (
  <i
    className='fas fa-chalkboard-teacher'
    style={{ marginRight: 5, fontSize: 15 }}
  ></i>
  // <svg
  //   xmlns='http://www.w3.org/2000/svg'
  //   width='24'
  //   height='24'
  //   viewBox='0 0 24 24'
  //   fill='none'
  //   stroke='currentColor'
  //   strokeWidth='2'
  //   strokeLinecap='round'
  //   strokeLinejoin='round'
  //   className='feather feather-book-open feather-icon'
  // >
  //   <path d='M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z'></path>
  //   <path d='M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z'></path>
  // </svg>
);

export const facturacion_svg = (
  <i
    className='fas fa-file-invoice'
    style={{ marginRight: 4, fontSize: 16 }}
  ></i>
  /*<svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='feather feather-file-text feather-icon'
  >
    <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'></path>
    <polyline points='14 2 14 8 20 8'></polyline>
    <line x1='16' y1='13' x2='8' y2='13'></line>
    <line x1='16' y1='17' x2='8' y2='17'></line>
    <polyline points='10 9 9 9 8 9'></polyline>
  </svg>*/
);
